module.exports = __webpack_public_path__ + "static/media/manager-offer.81fafff0.svg";